import { Store } from "@/store/store";
import GeoreferencingService from "../GeoreferencingService.js";
import errorManager from "@/modules/errors/error-services/error-manager.js";

class GeoreferencingStore extends Store {
  data() {
    return {
      history: [],
      count: 0,
      loading: false,
      error: null,
      hasInProgress: false,
      tasksTrigger: 0,
    };
  }

  async loadHistory(imei) {
    this.state.loading = true;
    this.state.error = null;
    try {
      const { data } = await GeoreferencingService.getHistory(imei);
      this.state.history = data || [];
      this.state.count = this.state.history.length;
    } catch (error) {
      errorManager.manage(
        error,
        errorManager.caseNotFound(() => {
          // 404 = no records, valid empty state
          this.state.history = [];
          this.state.count = 0;
        }),
        errorManager.defaultCase(() => {
          this.state.error = errorManager.error(error);
          this.state.history = [];
          this.state.count = 0;
        })
      );
    } finally {
      this.state.loading = false;
    }
  }

  reset() {
    this.state.history = [];
    this.state.count = 0;
    this.state.loading = false;
    this.state.error = null;
    this.state.hasInProgress = false;
    this.state.tasksTrigger = 0;
  }
}

export const georeferencingStore = new GeoreferencingStore("GEOREFERENCING");
